module.exports = __webpack_public_path__ + "assets/img/tammo-beishuizen.eec48fe0.jpg";